import React from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveTable } from '@fs/zion-ui'
import UploadRowSkeleton from '../../upload-page/upload-row/UploadRowSkeleton'
import GenealogyRow from './GenealogyRow'
import { useGenealogyTreesContext } from '../GenealogyTreesProvider'

const GenealogyTable = () => {
  const [t] = useTranslation()
  const { trees } = useGenealogyTreesContext()
  const genealogyTableHeaders = [
    t('common-ui:name.object'),
    t('tree-import.table-header.upload'),
    t('tree-import.table-header.people'),
    t('tree-import.table-header.size'),
    t('tree-import.table-header.status'),
    // This will give a blank heading but will read actions for screen readers for that table column
    { ariaLabel: t('tree-import.actions.label') },
  ]

  return (
    <ResponsiveTable
      verticalAlign="middle"
      stickyHeader={false}
      backgroundColor="transparent"
      caption={t('tree-import.manage-trees.genealogy-trees-heading')}
      totalColumnCount={6}
      atSizeColumns={{
        xl: {
          labels: genealogyTableHeaders,
          columnWidths: [4, 2, 1, 1, 1, 3],
        },
        default: {
          labels: genealogyTableHeaders,
          columnWidths: [3, 2, 2, 2, 2, 1],
        },
      }}
    >
      {trees ? (
        trees.map((tree, index) => {
          const key = `tree_${index}`
          return <GenealogyRow key={key} tree={tree} />
        })
      ) : (
        <>
          <UploadRowSkeleton />
          <UploadRowSkeleton />
          <UploadRowSkeleton />
        </>
      )}
    </ResponsiveTable>
  )
}

export default GenealogyTable
